import React from 'react';
import ClientContactMethodsEditButton from './ClientContactMethodsEditButton';

const ClientContactMethodsCell = (params) => {
    const id = params.row.cm_id;

    if (params.field === 'cm_edit') {
        return <ClientContactMethodsEditButton id={id} />;
    }

    return <>{params.value ?? ''}</>;
};

export default ClientContactMethodsCell;
